import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-xl shadow-2xl border-b border-gray-100'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <span className={`text-2xl md:text-3xl font-bold tracking-tight transition-all duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              INTER<span className="text-[#C9A961]">PRODUCTS</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('about')}
              className={`font-semibold transition-all text-base ${
                isScrolled 
                  ? 'text-gray-700 hover:text-[#C9A961]' 
                  : 'text-white hover:text-white hover:border-b-2 hover:border-[#C9A961] pb-1'
              }`}
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-semibold transition-all text-base ${
                isScrolled 
                  ? 'text-gray-700 hover:text-[#C9A961]' 
                  : 'text-white hover:text-white hover:border-b-2 hover:border-[#C9A961] pb-1'
              }`}
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`font-semibold transition-all text-base ${
                isScrolled 
                  ? 'text-gray-700 hover:text-[#C9A961]' 
                  : 'text-white hover:text-white hover:border-b-2 hover:border-[#C9A961] pb-1'
              }`}
            >
              Produtos
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className={`font-bold px-8 py-3 rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:scale-105 ${
                isScrolled
                  ? 'bg-[#2D5F7F] hover:bg-[#1e4159] text-white'
                  : 'bg-[#C9A961] hover:bg-[#b89850] text-gray-900'
              }`}
            >
              Contato
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-gray-700' : 'text-white'} size={28} />
            ) : (
              <Menu className={isScrolled ? 'text-gray-700' : 'text-white'} size={28} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-6 pb-6 flex flex-col space-y-4 bg-white rounded-2xl shadow-2xl p-6 border border-gray-100">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 font-semibold hover:text-[#C9A961] transition-colors text-left py-2"
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 font-semibold hover:text-[#C9A961] transition-colors text-left py-2"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 font-semibold hover:text-[#C9A961] transition-colors text-left py-2"
            >
              Produtos
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#2D5F7F] hover:bg-[#1e4159] text-white font-bold w-full py-3"
            >
              Contato
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
